<article>
  <div class="data-field status">
    <label class="b2">{{ 'PLANNING.PLANNING_ORDER_FIELDS.STATUSES' | bmsTranslate }}</label>
    <div class="status-container">
      <app-production-schedule-status-icon [withNewIcons]="true" [withTooltip]="true" [status]="getProductionOrderStatus()" [state]="getProductionOrderState()"></app-production-schedule-status-icon>
      @if (getIsDifferentConfiguration()) {
        <mat-icon class="icon icon-different-config" svgIcon="deviating" [matTooltip]="'PLANNING.STATUS.DIFFERENT_CONFIGURATION' | bmsTranslate" matTooltipPosition="above"></mat-icon>
      }
      @if (getIsPastDue()) {
        <mat-icon class="icon icon-past-due" svgIcon="clock" [matTooltip]="'PLANNING.STATUS.DUE' | bmsTranslate" matTooltipPosition="above"> </mat-icon>
      }
    </div>
  </div>
  @if (realTimeProgress | async; as progress) {
    <div class="data-field half machine">
      <label class="b2">{{ 'PLANNING.PLANNING_ORDER_FIELDS.MACHINE' | bmsTranslate: {count: 1} }}</label>
      <p class="b2"><vdw-ellipsis-label [text]="machine.name"></vdw-ellipsis-label></p>
    </div>
    <div class="data-field half progress">
      <label class="b2">{{ 'PLANNING.PLANNING_ORDER_FIELDS.PROGRESS' | bmsTranslate }}</label>
      <p class="b2">{{ progress.completionPercent | number: '1.0-0' }} %</p>
    </div>
    @if (isCarpet(order)) {
      <div class="data-field half creel">
        <label class="b2">{{ 'TEXTILE_DATA.CREEL.ENTITY' | bmsTranslate }}</label>
        @if (order.productionOrder?.creel) {
          <p class="b2">{{ order.productionOrder.creel.name }}</p>
        } @else {
          <ng-container *ngTemplateOutlet="notApplicable"></ng-container>
        }
      </div>
      <div class="data-field half quality">
        <label class="b2">{{ 'TEXTILE_DATA.MACHINE_QUALITY.MACHINE_QUALITY' | bmsTranslate: {count: 1} }}</label>
        @if (order.productionOrder?.quality) {
          <p class="b2">{{ order.productionOrder.quality.name }}</p>
        } @else {
          <ng-container *ngTemplateOutlet="notApplicable"></ng-container>
        }
      </div>
    }
    @if (isWeaving(order)) {
      <div class="data-field weave-product">
        <label class="b2">{{ 'TEXTILE_DATA.WEAVE_PRODUCT.WEAVE_PRODUCT' | bmsTranslate: {count: 1} }}</label>
        <p class="b2">{{ order.productionOrder.weaveProduct.name }}</p>
      </div>
    }
    @if (isTufting(order)) {
      <div class="data-field tuft-product">
        <label class="b2">{{ 'TEXTILE_DATA.TUFT_PRODUCT.TUFT_PRODUCT' | bmsTranslate: {count: 1} }}</label>
        <p class="b2">{{ order.productionOrder.tuftProduct.name }}</p>
      </div>
    }
    @if (isPlastic(order)) {
      <div class="data-field plastic-product">
        <label class="b2">{{ 'TEXTILE_DATA.PLASTIC_PRODUCT.PLASTIC_PRODUCT' | bmsTranslate: {count: 1} }}</label>
        <p class="b2">{{ order.productionOrder.plasticProduct.name }}</p>
      </div>
    }
    <div class="data-field half duration">
      <label class="b2">{{ 'PLANNING.PLANNING_ORDER_FIELDS.DURATION' | bmsTranslate }}</label>
      @if (order.actualStartDate) {
        <p class="b2">{{ getDuration() }}</p>
      } @else {
        <ng-container *ngTemplateOutlet="notApplicable"></ng-container>
      }
    </div>
    <div class="data-field half production-time">
      <label class="b2">{{ 'PLANNING.PLANNING_ORDER_FIELDS.ESTIMATED_PRODUCTION_TIME' | bmsTranslate }}</label>
      @if (order.estimatedProductionTime) {
        <p class="b2">{{ getProductionTime() }}</p>
      } @else {
        <ng-container *ngTemplateOutlet="notApplicable"></ng-container>
      }
    </div>
    <div class="data-field half produced">
      <label class="b2">{{ 'PLANNING.PLANNING_ORDER_FIELDS.QUANTITY_PRODUCED' | bmsTranslate }}</label>
      <p class="b2">{{ progress.quantityProduced | number: '1.0-0' }} {{ getQuantityUnit() | bmsTranslate }}</p>
    </div>
    <div class="data-field half required">
      <label class="b2">{{ 'PLANNING.PLANNING_ORDER_FIELDS.QUANTITY_REQUIRED' | bmsTranslate }}</label>
      <p class="b2">{{ progress.quantityRequired | number: '1.0-0' }} {{ getQuantityUnit() | bmsTranslate }}</p>
    </div>
  }
  <div class="data-field startDate">
    <label class="b2">{{ 'PLANNING.PLANNING_ORDER_FIELDS.START_DATE' | bmsTranslate }}</label>
    <p class="b2">{{ order.actualStartDate ?? forecast.estimatedStart | DateTime: 'DATETIME_MED_WITH_WEEKDAY' }}</p>
  </div>
  <div class="data-field endDate">
    <label class="b2">{{ 'PLANNING.PLANNING_ORDER_FIELDS.END_DATE' | bmsTranslate }}</label>
    @if (order.actualEndDate) {
      <p class="b2">{{ order.actualEndDate | DateTime: 'DATETIME_MED_WITH_WEEKDAY' }}</p>
    } @else {
      <ng-container *ngTemplateOutlet="notApplicable"></ng-container>
    }
  </div>
  <div class="data-field estimatedEndDate">
    <label class="b2">{{ 'PLANNING.PLANNING_ORDER_FIELDS.ESTIMATED_END_DATE' | bmsTranslate }}</label>
    <p class="b2">
      {{ forecast?.estimatedEnd ?? order.estimatedEndDate ?? order.actualEndDate | DateTime: 'DATETIME_MED_WITH_WEEKDAY' }}
    </p>
  </div>
  <div class="data-field dueDate">
    <label class="b2">{{ 'PLANNING.PLANNING_ORDER_FIELDS.DUE_DATE' | bmsTranslate }}</label>
    @if (order.productionOrder?.dueDate; as dueDate) {
      <p class="b2">{{ dueDate | DateTime: 'DATETIME_MED_WITH_WEEKDAY' }}</p>
    } @else {
      <ng-container *ngTemplateOutlet="notApplicable"></ng-container>
    }
  </div>

  <ng-template #notApplicable>
    <p class="b2">n/a</p>
  </ng-template>
</article>

@if (order.productionOrder) {
  <footer>
    @if (order.productionOrder.status === 'TO_RECONFIRM') {
      <button mat-stroked-button type="button" (click)="reconfirmOrder()">
        {{ 'PLANNING.ACTIONS.RECONFIRM' | bmsTranslate }}
      </button>
    }
    @if (!order.actualStartDate) {
      <button mat-stroked-button type="button" [disabled]="getIsStarted()" (click)="delete()">
        {{ 'PLANNING.ACTIONS.REMOVE' | bmsTranslate }}
      </button>
    }
    @if (order.productionOrder.status === 'CREATED') {
      <button mat-flat-button color="primary" type="button" (click)="reconfirmOrder()">
        {{ 'GENERAL.ACTIONS.CONFIRM' | bmsTranslate }}
      </button>
    }
    <button mat-flat-button color="primary" type="button" (click)="openOrderDetails()">
      {{ 'GENERAL.ORDER_DETAILS' | bmsTranslate }}
    </button>
  </footer>
}
